/**
 * Vazão medida dos blocos (bytes/s), para o motor saber se a reprodução vai
 * fluir: com 12 downloads ao mesmo tempo, a vazão de cada um não diz nada — a
 * conta é a soma dos bytes dos últimos pedidos sobre o intervalo de relógio que
 * eles ocuparam juntos (do primeiro começo ao último fim).
 */

export interface Amostra {
  bytes: number;
  inicio: number;
  fim: number;
}

/** Amostras guardadas e a idade máxima de cada uma. */
const MAX_AMOSTRAS = 48;
const IDADE_MAX_MS = 20_000;
/** Menos que isso não é medida (poucos bytes ou intervalo curto demais). */
const BYTES_MIN = 300_000;
const INTERVALO_MIN_MS = 200;

/** Vazão (bytes/s) das amostras recentes, ou null se ainda não há medida. Puro — testado. */
export function vazaoDe(amostras: readonly Amostra[], agora: number): number | null {
  const recentes = amostras.filter((a) => agora - a.fim <= IDADE_MAX_MS);
  if (!recentes.length) return null;
  let bytes = 0;
  let inicio = Infinity;
  let fim = -Infinity;
  for (const a of recentes) {
    bytes += a.bytes;
    inicio = Math.min(inicio, a.inicio);
    fim = Math.max(fim, a.fim);
  }
  const ms = fim - inicio;
  if (bytes < BYTES_MIN || ms < INTERVALO_MIN_MS) return null;
  return (bytes / ms) * 1000;
}

const amostras: Amostra[] = [];

/** Mais rápido que isso veio do cache HTTP do navegador, não da rede. */
const DURACAO_MIN_MS = 10;

export function registrarVazao(bytes: number, inicio: number, fim: number): void {
  if (!(bytes > 0) || !(fim - inicio >= DURACAO_MIN_MS)) return;
  amostras.push({ bytes, inicio, fim });
  if (amostras.length > MAX_AMOSTRAS) amostras.splice(0, amostras.length - MAX_AMOSTRAS);
}

/** Vazão atual dos blocos (bytes/s), ou null sem medida recente. */
export const vazaoDosBlocos = (agora: number = performance.now()) => vazaoDe(amostras, agora);

/** (testes) zera. */
export const zerarVazao = () => {
  amostras.length = 0;
};
